<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ow2lUE/tc-custom/9781423639954.jpg?1694214172098" alt="This image is the cover for the book Bonjour Y'all"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bonjour Y'all
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A French &amp; European/Southern-fusion cookbook . . . a 150-page sensory delight” from the renowned Myrtle Beach chef Heidi Vukov (<i>Grand Strand</i>).</b></p><p>“Bonjour, Y’All,” the slogan for Heidi Vukov’ Croissants Bistro and Bakery in Myrtle Beach, South Carolina, perfectly encapsulates the popular restaurant’s elegant and delicious pairing of two distinct culinary traditions—European cuisine and Southern home cooking. This book celebrates Croissants’ diversity, featuring dozens of menu delights such as Crab Cakes, Angry Bulls Bay Clams, and Peach Pork Tenderloin, recipes that successfully combine the elegance and finesse of the French palate with the hospitality and warmth of the Southern kitchen. Also included among the more than fifty recipes are German- and Italian-inspired dishes, summer cocktails, and sumptuous confections such as Black Forest Torte from Croissants’ award-winning European bakery.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heidi Vukov, Sara Sobota
      </h2>
      
      <p class="authorDescription body article">HEIDI VUKOV moved from Pennsylvania to South Carolina in the early 1990s, and shortly thereafter opened Croissants Bistro and Bakery in Myrtle Beach. Since then, she’s been named South Carolina Restaurateur of the Year and Croissants has become a destination restaurant on the South Carolina coast. Heidi lives in Myrtle Beach with her husband, Gary, and has four children scattered across the United States in Utah, Tennessee, Washington, D.C., and California.Sara Sobota has been a freelance writer in the Myrtle Beach area for twenty years. Her travel and lifestyle writing has appeared in such magazines as US Airways and Agent@Home, and she also blogs for the Huffington Post. She teaches composition, journalism, and business communication at Coastal Carolina University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df13f3e6